/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import { gql } from '@apollo/client';

export const LIST_DEPARTMENTS = gql(`
  query ListDepartments(
    $limit: Int = 1000
    $nextToken: String
    $deptFilter: ListDepartmentsFilter
  ) {
    listDepartments(
      limit: $limit
      nextToken: $nextToken
      deptFilter: $deptFilter
    ) {
      items {
        id
        owner
        organizationId
        name
        draftKnowledgeId
        publishedKnowledgeId
        workerId
        local
        state
        errors
        createdAt
        isDeleted
        brainVersion
        features
        organization {
          id
          name
          createdAt
          owner
          updatedAt
        }
        draftKnowledge {
          departmentId
          id
          brainVersion
        }
      }
      nextToken
    }
  }
`);

export const LIST_ALL_DEPARTMENTS = gql`
  query ListAllDepartments($limit: Int = 1000, $nextToken: String) {
    listAllDepartments(limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        name
        local
        createdAt
        brainVersion
        features
        organization {
          id
          name
        }
      }
      nextToken
    }
  }
`;

export const GET_DEPARTMENT = gql`
  query GetDepartment($id: ID!) {
    getDepartment(id: $id) {
      id
      owner
      organizationId
      name
      draftKnowledgeId
      publishedKnowledgeId
      workerId
      local
      state
      errors
      createdAt
      isDeleted
      brainVersion
      features
      organization {
        id
        name
      }
      draftKnowledge {
        id
        brainVersion
      }
    }
  }
`;

export const LIST_DEPARTMENT_COLLABORATORS = gql(`
  query ListDepartmentCollaborators(
    $departmentId: String!
    $role: AccessControlRole
    $limit: Int = 1000
    $nextToken: String
  ) {
    listDepartmentCollaborators(
      departmentId: $departmentId
      role: $role
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        role
      }
      nextToken
    }
  }
`);

export const GET_DEPARTMENT_HISTORY = gql`
  query GetDepartmentHistory(
    $departmentId: ID!
    $entityName: DepartmentBookEntity
    $entityIDs: [String!]
    $start: String
    $end: String
    $limit: Int = 10
    $nextToken: String
  ) {
    getDepartmentHistory(
      departmentId: $departmentId
      entityName: $entityName
      entityIDs: $entityIDs
      start: $start
      end: $end
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        entityId
        user
        operation
        entityName
        timestamp
        name
        rollbackVersion
        publishedVersion
      }
      nextToken
    }
  }
`;

export const EXPORT_DEPARTMENT = gql`
  query ExportDepartment($departmentId: ID!, $version: String) {
    exportDepartment(departmentId: $departmentId, version: $version) {
      formatVersion
      departmentID
      departmentVersion
      checksum
      features
      procedures {
        id
        name
        text
        language
      }
      facts {
        name
        values
      }
      learnedBooks {
        ids
      }
      learnings {
        id
        stage
        questionType
        stepPath
        lexicalPath
        procedureId
        action
        literalValue
        choices
        conceptId
        technique
        retryTimeout
        retryMinimumDelay
        newSteps
        oauth2Metadata
      }
      contextualLearningInfo {
        procedureId
        learningId
        questionType
        stepPath
        lexicalPath
        contextValue
        contextVector
        contextMetadata
      }
    }
  }
`;
